import { createFileRoute } from '@tanstack/react-router';
import { NovaFazendaView } from '@/modules/agronomia/components/NovaFazendaView';

// Tela · Cadastro de nova fazenda (mobile, full-bleed). ?cpf= prefixa o produtor dono.
export const Route = createFileRoute('/_authed/agronomia_/nova-fazenda')({
  validateSearch: (s: Record<string, unknown>): { cpf?: string } => {
    const cpf = typeof s.cpf === 'string' ? s.cpf : undefined;
    return cpf ? { cpf } : {};
  },
  component: Page,
});

function Page() {
  const { cpf } = Route.useSearch();
  return <NovaFazendaView cpf={cpf} />;
}
